import angular from 'angular';
import uiRouter from 'angular-ui-router';
import episodechangereportComponent from './episodechangereport.component';

let episodechangereportModule = angular.module('episodechangereport', [
  uiRouter
])

.component('episodechangereport', episodechangereportComponent);

export default episodechangereportModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/episodechangereport/episodechangereport.js